import { useTranslation } from '@dreamstack/i18n'
import type { PropertyImage } from '@dreamstack/web/lib/prisma/properties'
import type { FunctionComponent } from 'react'
import { CallToActionTile } from '../project/CallToActionTile'

type FloorfyLink = {
  id: number
  title: string
  url: string
  is_private: boolean
  tags: string[]
  is_embedable: boolean
}

export const PropertyDocuments: FunctionComponent<
  React.PropsWithChildren<{
    floorPlan?: PropertyImage
    floorfyLink?: FloorfyLink
  }>
> = ({ floorPlan, floorfyLink }) => {
  const t = useTranslation()
  return (
    <div className="mt-px-48 flex flex-col gap-y-4 gap-x-4 col-span-12 md:flex-row ml:mt-px-96 ml:space-x-px-40 ml:space-y-0 lg:mt-px-196">
      <div className="flex-1">
        {!!floorPlan && (
          <CallToActionTile
            targetBlank
            big
            caption={t('accentro:groundplan')}
            href={floorPlan.url}
          />
        )}
        <div className="flex-1"></div>
      </div>
      <div className="flex-1">
        {!!floorfyLink && !floorfyLink.is_private && (
          <CallToActionTile
            targetBlank
            big
            caption={t('accentro:floorfy')}
            href={floorfyLink.url}
          />
        )}
      </div>
    </div>
  )
}
